import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "x_panel" };
const _hoisted_3 = { class: "x_title" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "clearfix" };
const _hoisted_7 = { class: "x_content" };
const _hoisted_8 = { class: "clearfix top10" };
const _hoisted_9 = { class: "clearfix" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_11 = { class: "input-group top_search" };
const _hoisted_12 = { class: "input-group-btn" };
const _hoisted_13 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-4"
};
const _hoisted_14 = { class: "input-group top_search" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_16 = { class: "input-group top_search" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_18 = { class: "float-end mt-1" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12" };
const _hoisted_20 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_21 = { class: "table table-hover small bottom0 pw100" };
const _hoisted_22 = { class: "clearfix" };
const _hoisted_23 = { class: "clearfix" };
const _hoisted_24 = { class: "float-start right5" };
const _hoisted_25 = { class: "text-center" };
const _hoisted_26 = { key: 0 };
const _hoisted_27 = { class: "data-grid-footer clearfix detached pw100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1 /* TEXT */),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_b_button, {
                                type: "button",
                                onClick: _ctx.finished,
                                variant: "secondary"
                            }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                        _createElementVNode("i", { class: "fa fa-close" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", {
                                            class: "hidden-xs",
                                            style: { "color": "white" }
                                        }, " Return", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ])
                    ])
                ])
            ]),
            _cache[32] || (_cache[32] = _createTextVNode()),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_b_form_input, {
                                    modelValue: _ctx.query.keywords,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                    modelModifiers: { trim: true },
                                    type: "text",
                                    placeholder: "Search for...",
                                    onKeyup: _withKeys(_ctx.search, ["enter"]),
                                    required: ""
                                }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_12, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-default",
                                        onClick: _cache[1] || (_cache[1] =
                                            //@ts-ignore
                                            (...args) => (_ctx.search && _ctx.search(...args)))
                                    }, [...(_cache[9] || (_cache[9] = [
                                            _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                        ]))])
                                ])
                            ])
                        ]),
                        _cache[16] || (_cache[16] = _createTextVNode()),
                        (_ctx.showSiteFilter)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.siteId,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.siteId) = $event)),
                                        options: _ctx.siteOptions,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Any site",
                                        class: "multiselect-small"
                                    }, {
                                        noResult: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[17] || (_cache[17] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.systemStatus,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.systemStatus) = $event)),
                                    options: _ctx.systemStatusOptions,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "All systems",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _cache[18] || (_cache[18] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                (_ctx.hasSystemsToGrant())
                                    ? (_openBlock(), _createBlock(_component_b_button, {
                                        key: 0,
                                        type: "button",
                                        variant: "primary",
                                        class: "mb-0",
                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.grantAll())),
                                        size: "sm"
                                    }, {
                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* CACHED */),
                                                _createElementVNode("span", { class: "hidden-xs" }, " Authorize All", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _cache[15] || (_cache[15] = _createTextVNode()),
                                (_ctx.hasSystemsToRevoke())
                                    ? (_openBlock(), _createBlock(_component_b_button, {
                                        key: 1,
                                        type: "button",
                                        variant: "danger",
                                        class: "mb-0",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.revokeAll())),
                                        size: "sm"
                                    }, {
                                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* CACHED */),
                                                _createElementVNode("span", { class: "hidden-xs" }, " Unauthorize All", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    _cache[31] || (_cache[31] = _createTextVNode()),
                    _withDirectives(_createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("table", _hoisted_21, [
                                _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tSystem\r\n\t\t\t\t\t\t\t\t\t\t"),
                                        _createTextVNode(),
                                        _createElementVNode("th", { class: "text-center" }, "\r\n\t\t\t\t\t\t\t\t\t\t\tAuthorized\r\n\t\t\t\t\t\t\t\t\t\t")
                                    ])
                                ], -1 /* CACHED */)),
                                _cache[28] || (_cache[28] = _createTextVNode()),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", null, [
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    _createElementVNode("b", null, _toDisplayString(item.systemName), 1 /* TEXT */)
                                                ]),
                                                _cache[20] || (_cache[20] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa fa-map-marker" }, null, -1 /* CACHED */)),
                                                        _createTextVNode(" " + _toDisplayString(item.siteName), 1 /* TEXT */)
                                                    ])
                                                ])
                                            ]),
                                            _cache[25] || (_cache[25] = _createTextVNode()),
                                            _createElementVNode("td", _hoisted_25, [
                                                (item.hasAccessToCompanySystems)
                                                    ? _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                                        key: 0,
                                                        type: "button",
                                                        variant: "primary",
                                                        title: "User has access to all systems for this company.",
                                                        size: "sm"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                                _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* CACHED */),
                                                                _createElementVNode("span", { class: "hidden-xs" }, " Authorized", -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    })), [
                                                        [
                                                            _directive_b_tooltip,
                                                            void 0,
                                                            void 0,
                                                            { hover: true }
                                                        ]
                                                    ])
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        (!item.hasAccessToSystem)
                                                            ? (_openBlock(), _createBlock(_component_b_button, {
                                                                key: 0,
                                                                type: "button",
                                                                variant: "danger",
                                                                onClick: ($event) => (_ctx.grant(item)),
                                                                size: "sm"
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                                        _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* CACHED */),
                                                                        _createElementVNode("span", { class: "hidden-xs" }, " Not Authorized", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]))
                                                            : _createCommentVNode("v-if", true),
                                                        _cache[24] || (_cache[24] = _createTextVNode()),
                                                        (item.hasAccessToSystem)
                                                            ? (_openBlock(), _createBlock(_component_b_button, {
                                                                key: 1,
                                                                type: "button",
                                                                variant: "primary",
                                                                onClick: ($event) => (_ctx.revoke(item)),
                                                                size: "sm"
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                                        _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* CACHED */),
                                                                        _createElementVNode("span", { class: "hidden-xs" }, " Authorized", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]))
                                                            : _createCommentVNode("v-if", true)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                            ])
                                        ]));
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                ]),
                                _cache[29] || (_cache[29] = _createTextVNode()),
                                _createElementVNode("tfoot", null, [
                                    (_ctx.noData)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [...(_cache[26] || (_cache[26] = [
                                                _createElementVNode("td", {
                                                    colspan: "2",
                                                    class: "text-center"
                                                }, [
                                                    _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                ], -1 /* CACHED */)
                                            ]))]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ]),
                        _cache[30] || (_cache[30] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_b_pagination, {
                                class: "float-end",
                                modelValue: _ctx.query.pageNo,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.query.pageNo) = $event)),
                                "per-page": _ctx.query.pageSize,
                                "total-rows": _ctx.data.recordCount,
                                "hide-ellipsis": true,
                                disabled: _ctx.working
                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                        ])
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.searchAttempted]
                    ])
                ])
            ])
        ])
    ]));
}
